// albumTracksSlice.js
import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";
import axios from "axios";

const createslicethunk = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

const ArtistAlbumSlice = createslicethunk({
  name: "ArtistAlbum",
  initialState: {
    albums: null,
    status: "idle",
    error: null,
  },
  reducers: (create) => ({
    fetchArtistAlbums: create.asyncThunk(
      async () => {
        const ArtistId = localStorage.getItem("artistId");
        const accessToken = localStorage.getItem("access_token");
        try {
          const response = await axios.get(
            `
https://api.spotify.com/v1/artists/${ArtistId}/albums?include_groups=album&limit=50`,
            {
              headers: {
                Authorization: ` Bearer ${accessToken} `,
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
          return response.data.items;
        } catch (error) {
          return error.response.data;
        }
      },
      {
        pending: (state) => {
          state.status = "loading";
        },
        rejected: (state, action) => {
          state.error = action.error;
          state.status = "failed";
        },
        fulfilled: (state, action) => {
          state.status = "succeeded";
          state.albums = action.payload;
        },
      }
    ),
  }),
});

export default ArtistAlbumSlice.reducer;
export const { fetchArtistAlbums } = ArtistAlbumSlice.actions;
